import { Component, computed, EventEmitter, Input, Output, signal } from '@angular/core';

@Component({
  selector: 'app-account-locked',
  standalone: false,
  templateUrl: './account-locked.component.html',
  styleUrl: './account-locked.component.scss',
})
export class AccountLockedComponent {

  @Input() minutesLeft = 5;
  @Output() onResetPassword = new EventEmitter<void>();
  @Output() onExpired = new EventEmitter<void>();

  private intervalId: ReturnType<typeof setInterval> | null = null;

  remainingSeconds = signal(0);

  minutes = computed(() =>
    String(Math.floor(this.remainingSeconds() / 60)).padStart(2, '0')
  );
  seconds = computed(() =>
    String(this.remainingSeconds() % 60).padStart(2, '0')
  );

  isExpired = computed(() => this.remainingSeconds() <= 0);



  ngOnInit(): void {
    this.remainingSeconds.set(this.minutesLeft * 60);
    this.startCountdown();
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  private startCountdown(): void {
    this.intervalId = setInterval(() => {
      this.remainingSeconds.update(s => Math.max(s - 1, 0));
      if (this.remainingSeconds() <= 0) {
        this.stopCountdown();
        this.onExpired.emit();
      }
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  // Parse minutesLeft from backend error string if needed
  // e.g. parseMinutesFromError("Account locked. Try again in 14 minute(s).")
  static parseMinutesFromError(message: string): number {
    const match = message.match(/(\d+)\s*minute/i);
    return match ? parseInt(match[1], 10) : 5;
  }

}
